(() => {
  if (window.jwTouchProductPreview) return;
  window.jwTouchProductPreview = true;
  const touch = matchMedia('(hover: none), (pointer: coarse)');
  let active;
  const clear = () => { active?.classList.remove('is-touch-preview'); active = null; };
  document.addEventListener('click', event => {
    if (!touch.matches || event.detail === 0 || event.ctrlKey || event.metaKey) return;
    const media = event.target.closest('.jw-hover-media, .jw-slide');
    const alternate = media?.querySelector('.jw-hover-lifestyle, .jw-gallery-hover');
    if (!alternate) { clear(); return; }
    if (active === media) return;
    clear(); active = media; media.classList.add('is-touch-preview');
    event.preventDefault(); event.stopImmediatePropagation();
  }, true);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') clear(); });
  touch.addEventListener('change', clear);
})();
